import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";
import { useState } from "react";
import { IvideonHistoryActsIProps } from "../model/schema";

export const useGetIvideonHistoryActs = () => {
  const [params, setParams] = useState<IvideonHistoryActsIProps>();
  const { getIvideonHistoryActs } = useIvideon();

  const getParams = (props: IvideonHistoryActsIProps) => {
    setParams(props);
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getIvideonHistoryActs", JSON.stringify(params)],
    queryFn: () => getIvideonHistoryActs(params!),
    onError: (error) => {
      console.log(error);
    },
    enabled: !!params,
  });

  return { data, isLoading, isError, refetch, getParams };
};
